import { Descendant } from 'slate';
import { DescendantExecuteContext } from '../PolicyForm';
import { permissionNameIdMap } from 'hooks/business/useNewPermisson';
import { scenarioPermissionMap } from '../config';
import { getRegions } from '../Policy';

export interface PolicyFormValues
  extends Omit<
    Aide.Policy,
    | 'id'
    | 'taskId'
    | 'roundId'
    | 'priority'
    | 'bilingualExecuteContext'
    | 'bilingualExecuteContexts'
    | 'regionExecuteContexts'
    | 'executeItemContext'
    | 'cancelTradeConfig'
  > {
  id?: Marketing.Policy['id'];
  bilingualExecuteContext: DescendantExecuteContext;
  bilingualExecuteContexts: DescendantExecuteContext[];
  regionExecuteContexts?: {
    enable: boolean;
    region: General.UpperCaseRegion;
    replyNumbers?: string[];
    receptionScoreConfig?: import('components/ReceptionScore/model').ScoreConfig;
    executeContext: DescendantExecuteContext;
  }[];
  regions?: General.UpperCaseRegion[];
  executeItemContext: {
    itemId: string;
    customizeContext?: Descendant[];
  }[];
  cancelTradeConfig?: Omit<Required<Marketing.Policy>['cancelTradeConfig'], 'contents'> & {
    contents: (Omit<
      Util.ElementType<Required<Marketing.Policy>['cancelTradeConfig']['contents']>,
      'executeContext'
    > & {
      receptionScoreConfig?: import('components/ReceptionScore/model').ScoreConfig;
      executeContext: DescendantExecuteContext;
    })[];
  };
}

export type FV = PolicyFormValues;

export const getFormRegions = (
  scenarioType: Marketing.AllScenarioType,
  platform: General.PlatformUpperCase,
  regionStoreList: Marketing.RegionStore[],
) => {
  const regions = regionStoreList.reduce<(General.UpperCaseRegion | 'ALL')[]>(
    (res, { region }) => {
      res.push(region);
      return res;
    },
    [],
  );

  return regions.includes('ALL')
    ? getRegions(platform, permissionNameIdMap[scenarioPermissionMap[scenarioType]]).then(
        ({ regions }) => regions,
      )
    : Promise.resolve(regions as General.UpperCaseRegion[]);
};
